import {
  LayoutDashboard, Contact, Users, Image, FileText, ClipboardList,
  CalendarRange, Factory, ShieldCheck, Boxes, ShoppingCart, Truck,
  Building2, Wallet, UserCog, Wrench, BarChart3, Settings, Lock, Layers, Package,
} from "lucide-react";

// Nav registry. `module` maps to the RBAC module key (view permission gates visibility).
export const NAV_SECTIONS = [
  {
    title: "Overview",
    items: [{ label: "Dashboard", to: "/dashboard", icon: LayoutDashboard, module: "dashboard" }],
  },
  {
    title: "Sales",
    items: [
      { label: "CRM / Enquiries", to: "/crm", icon: Contact, module: "crm" },
      { label: "Customers", to: "/customers", icon: Users, module: "customers" },
      { label: "Product Master", to: "/products", icon: Package, module: "products" },
      { label: "Artwork", to: "/artwork", icon: Image, module: "artwork" },
      { label: "Quotations", to: "/quotations", icon: FileText, module: "quotations" },
      { label: "Sales Orders", to: "/sales-orders", icon: ClipboardList, module: "sales_orders" },
    ],
  },
  {
    title: "Operations",
    items: [
      { label: "Production Planning", to: "/production-planning", icon: CalendarRange, module: "production_planning" },
      { label: "Production", to: "/production", icon: Factory, module: "production" },
      { label: "Quality Control", to: "/quality-control", icon: ShieldCheck, module: "quality_control" },
      { label: "Inventory", to: "/inventory", icon: Boxes, module: "inventory" },
      { label: "Raw Material Stock", to: "/raw-materials", icon: Layers, module: "raw_materials" },
      { label: "Dispatch", to: "/dispatch", icon: Truck, module: "dispatch" },
    ],
  },
  {
    title: "Procurement",
    items: [
      { label: "Purchase", to: "/purchase", icon: ShoppingCart, module: "purchase" },
      { label: "Suppliers", to: "/suppliers", icon: Building2, module: "suppliers" },
    ],
  },
  {
    title: "Business",
    items: [
      { label: "Finance & Accounts", to: "/finance", icon: Wallet, module: "finance" },
      { label: "HR & Employees", to: "/hr", icon: UserCog, module: "hr" },
      { label: "Machines", to: "/machines", icon: Wrench, module: "machines" },
      { label: "Reports", to: "/reports", icon: BarChart3, module: "reports" },
    ],
  },
  {
    title: "Administration",
    items: [
      { label: "Settings & Masters", to: "/settings", icon: Settings, module: "settings" },
      { label: "User Management", to: "/users", icon: Lock, module: "user_management" },
    ],
  },
];
